<template lang="pug">
div
  v-row(v-masonry='' transition-duration='0.3s' item-selector='.item')
    v-col.item(v-for='i in artis' :key='`marti_${i.metano}`' v-masonry-tile='' cols='12' :md='12/3')
      v-card(:id='`masonry_${i.metano}`')
        v-card-title
          span(v-html='i.title')
        v-card-title(v-if="i.title2")
          span(v-html='i.title2')
        v-card-subtitle(v-if='arti_subtitle(i)' v-text='arti_subtitle(i)')
        div(v-for='(j,n) in arti_images(i)' :key='`farti_${i.metano}_img_${n}`')
          v-img(:src='j.src' :alt='j.alt' max-height='320' contain='' @load='redraw_masonry')
          v-card-subtitle(v-if='j.alt' v-text='j.alt')
        v-card-text(v-if='short_hilit(i)' v-html='short_hilit(i)')
        v-card-text(v-if='i.content' v-html='i.content')
        v-card-subtitle(v-if='arti_meta(i)' v-html='arti_meta(i)')
        v-card-actions
          v-spacer
          v-btn(icon='' tile='' small='' target='_blank' :to='to_artiview(i, q)')
            v-icon mdi-open-in-new
  v-row(v-if='progressive')
    div(v-intersect='on_artis_bottom_visible')
  v-row(v-show='artis.length == items.length')
    v-divider
</template>
<script>
import {debug} from "@/api/logging"
import { ref, computed, watch } from '@vue/composition-api'

const items_step = 20
const pre_hilit_max = 10
const post_hilit_max = 26

function short_hilit(i) {
  if(!i.highlights || i.highlights.length == 0) return undefined
  let s = i.highlights[0]
  // debug('short_hilit', i, Boolean(i.highlights), i.highlights.length, i.highlights[0])
  let n = s.search('<span class="hilit')
  if(n > pre_hilit_max) {
    s = s.slice(n - pre_hilit_max)
  }
  n = s.search('</span>')
  if((s.length - n) > post_hilit_max) {
    s = s.slice(0, s.length - n + post_hilit_max)
  }
  return s
}

function arti_meta(i) {
  var mm = []
  if(i.pubtime) {
    mm.push(this.$u.pubtime_str(i.pubtime))
  }
  if(i.volno && !['wai'].includes(i.metano.slice(0, 3))) {
    mm.push(i.volno)
  }
  if(i.authors) {
    mm.push(i.authors)
  }
  // if(i.word) {
  //   mm.push(i.word)
  // }
  if(i.sourcesdes) {
    mm.push(i.sourcesdes)
  }
  if(i.dynasty) {
    mm.push(i.dynasty)
  }
  if(i.pages) {
    mm.push(`${i.pages}頁`)
  }
  const s = mm.join('／')
  return s
}

function arti_images(i) {
  // debug('i', i)
  var rr = []
  if(Array.isArray(i.images)) {
    i.images.forEach((j)=>{
      const src = this.$u.fix_image_src(i.metano.slice(0, 3), j.src, {small:true})
      const alt = j.alt
      rr.push({src, alt})
    })
  }
  // debug('rr', rr)
  return rr.slice(0, 1)
}

function arti_subtitle(i) {
  var mm = []
  if(i.column) {
    mm.push(i.column)
  }
  else if(i.metano.slice(0, 3) == 'lio' && i.keyword) {
    // TODO: 資料修正後應移除此 workaround
    mm.push(i.keyword)
  }
  const s = mm.join('／')
  return s
}

export default {
  name: "MasonryArtis",
  props: {
    items: {
      type: Array,
      required: true,
    },
    progressive: {
      type: Boolean,
      default: false,
    },
    q: String,
  },
  components: {
  },
  setup(props, {emit}) {
    const items_max = ref(items_step)
    return {
      items_max,
    }
  },
  methods: {
    to_artiview(v, q) {
      const uniname = v.metano.slice(0, 3)
      const metaNo = v.metano
      if(q) {
        return {name: 'ArtiView', params: {uniname, metaNo}, query: this.$q({q})}
      }
      else {
        return {name: 'ArtiView', params: {uniname, metaNo}, query: this.$q({})}
      }
    },
    redraw_masonry() {
      const that = this
      if(that.$masonry_redraw_timeout) {
        clearTimeout(that.$masonry_redraw_timeout)
      }
      that.$masonry_redraw_timeout = setTimeout(()=>{
        // debug('$redrawVueMasonry()')
        that.$redrawVueMasonry()
        delete that.$masonry_redraw_timeout
      }, 200)
    },
    arti_meta,
    arti_images,
    arti_subtitle,
    short_hilit,
    on_artis_bottom_visible(entries, observer) {
      const isIntersecting = entries[0].isIntersecting
      if(isIntersecting) {
        this.items_max =
          (this.items_max < this.items.length - items_step)
          ? this.items_max + items_step
          : this.items.length
      }
      this.items_max =
        (this.items_max > items_step)
        ? this.items_max
        : items_step
      this.redraw_masonry()
      debug('on_artis_bottom_visible', isIntersecting, this.items_max, entries, observer)
    },
  },
  updated() {
    this.redraw_masonry()
  },
  mounted() {
    this.redraw_masonry()
  },
  computed: {
    artis() {
      const rr = this.progressive ? this.items.slice(0, this.items_max) : this.items
      // debug('artis', typeof(rr), rr)
      return rr
    },
  },
  watch: {
    items(v) {
      this.items_max = items_step
    },
  },
}
</script>
